import { render, staticRenderFns } from "./ddk.vue?vue&type=template&id=4288eeed&scoped=true&"
import script from "./ddk.vue?vue&type=script&lang=js&"
export * from "./ddk.vue?vue&type=script&lang=js&"
import style0 from "./ddk.vue?vue&type=style&index=0&id=4288eeed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4288eeed",
  null
  
)

export default component.exports